var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "perspective-active-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Задание перспективы")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/perspective_lines.png") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-text-area bold-text" }, [
        _vm._v("\n        Рекомендация:\n    ")
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/perspective_tip.png") }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Переместите\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("точки плоскости")
      ]),
      _vm._v(" таким образом, чтобы образующие её\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("отрезки")]),
      _vm._v(" совпадали с видимыми на фотографии\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("линиями перспективы.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("\n        Для корректного отображения "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("одного материала")
      ]),
      _vm._v(" на\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("разных отрезках стены")
      ]),
      _vm._v(", находящихся в\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("одной плоскости")
      ]),
      _vm._v(", линии перспективы должны\n        "),
      _c("span", { staticClass: "red-text bold-text" }, [_vm._v("совпадать")]),
      _vm._v(".\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }